import styled from "styled-components";
import { AppButton } from "components/button";

export const FormSubmitButton = styled(AppButton)`
  width: 120px;
`;
